var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsCheckmarkGreen = function SvgIconsCheckmarkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.791 5.333 8.215 16.91l-4.606-4.605-.942.943 5.548 5.548 12.519-12.52z",
    fill: "#74F59E",
    fillRule: "evenodd"
  })));
};
export { SvgIconsCheckmarkGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xOS43OTEgNS4zMzMgOC4yMTUgMTYuOTFsLTQuNjA2LTQuNjA1LS45NDIuOTQzIDUuNTQ4IDUuNTQ4TDIwLjczNCA2LjI3NnoiIGZpbGw9IiM3NEY1OUUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";